import { CompanyStateChange } from "./change-company-state.model";
var ChangeCompanyStateController = /** @class */ (function () {
    /*@ngInject*/
    function ChangeCompanyStateController($rootScope, $timeout, companyService, planService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$timeout = $timeout;
        this.companyService = companyService;
        this.planService = planService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    ChangeCompanyStateController.prototype.$onInit = function () {
        //flags
        this.changingStateFlag = false;
        this.isTrialPlanActive = false;
        this.isLoading = true;
        //variables
        this.stateText = "";
        this.assessmentsLeft;
        this.jobBoardsPullLeft;
        this.date;
        this.time;
        this.note;
        this.companyChangeStateObject = new CompanyStateChange();
        this.companyChangeStateObject.userId = this.$rootScope.userDetails.id;
        this.companyChangeStateObject.companyId = this.companyInfo.companyId;
        this.companyChangeStateObject.companyState = this.changeToState;
        this.companyChangeStateObject.techAssessmentLimitForSoftHold = 5;
        this.getCompanyPlanDetails();
        this._setDateAndTime();
        this._setStateText();
        this._setNote();
    };
    ChangeCompanyStateController.prototype.getCompanyPlanDetails = function () {
        var _this = this;
        this.planService.getCompanyPlanDetails(this.companyInfo.companyId, function (data) {
            if (data && data.plan) {
                _this.isTrialPlanActive = data.plan == "Trial" ? true : false;
                if (_this.changeToState == 'SoftHold') {
                    if (_this.isTrialPlanActive) {
                        _this.getAvailableAssessments();
                        _this.getAvailableJobBoardsPull();
                    }
                    else {
                        _this._setAssessmentLimitDefault(data.plan);
                        _this.isLoading = false;
                    }
                }
                else {
                    _this.isLoading = false;
                }
            }
            _this.isLoading = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    ChangeCompanyStateController.prototype.getAvailableAssessments = function () {
        var _this = this;
        var jobId = null;
        this.planService.getAvailableTechAssessmentsCount(this.companyInfo.companyId, jobId, function (data) {
            _this.assessmentsLeft = data["techAssessmentsLeft"];
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    ChangeCompanyStateController.prototype.getAvailableJobBoardsPull = function () {
        var _this = this;
        this.planService.getAvailableJobBoardsPullCount(this.companyInfo.companyId, function (data) {
            _this.jobBoardsPullLeft = data["jobBoardResumesLeftCount"];
            _this.isLoading = false;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    ChangeCompanyStateController.prototype._setAssessmentLimitDefault = function () {
        var _this = this;
        this.planService.getCurrentPlan(this.companyInfo.companyId, function (data) {
            if (data.planHeaderDto.planType == 'Month to Month') {
                _this.companyChangeStateObject.techAssessmentLimitForSoftHold = 10;
            }
            else {
                _this.companyChangeStateObject.techAssessmentLimitForSoftHold = 25;
            }
            // this.companyChangeStateObject.jbiLimitForSoftHold = 50;
        }, function (error) {
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    ChangeCompanyStateController.prototype._setDateAndTime = function () {
        var _this = this;
        this.date = moment().format('ll');
        this.time = moment().format('hh:mm:ss a');
        this.$timeout(function () {
            _this._setDateAndTime();
        }, 1000);
    };
    ChangeCompanyStateController.prototype._setStateText = function () {
        if (this.changeToState == 'Active') {
            this.stateText = "Release";
        }
        else if (this.changeToState == 'SoftHold') {
            this.stateText = "Soft Hold";
        }
        else {
            this.stateText = this.changeToState;
        }
    };
    ChangeCompanyStateController.prototype._setNote = function () {
        this.companyChangeStateObject.note = this.stateText + " Company";
    };
    ChangeCompanyStateController.prototype.changeCompanyState = function () {
        var _this = this;
        this.companyService.changeCompanyState(this.companyChangeStateObject, function (data) {
            _this.changingStateFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage("Company '" + _this.companyInfo.companyName + "' state changed to " + _this.stateText + " successfully", 'success');
            if (_this.saveCallback) {
                _this.saveCallback();
            }
        }, function (error) {
            _this.changingStateFlag = false;
            _this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    };
    ChangeCompanyStateController.prototype.cancel = function () {
        if (this.cancelCallback) {
            this.cancelCallback();
        }
    };
    ChangeCompanyStateController.prototype.receiveFormalizedComment = function (event) {
        this.companyChangeStateObject.note = event;
    };
    ChangeCompanyStateController.prototype.onVoiceTranscript = function (transcript) {
        if (this.companyChangeStateObject.note) {
            this.companyChangeStateObject.note += ' ' + transcript;
        }
        else {
            this.companyChangeStateObject.note = transcript;
        }
    };
    return ChangeCompanyStateController;
}());
ChangeCompanyStateController.$inject = ['$rootScope', '$timeout', 'companyService', 'planService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './change-company-state.html';
import * as TEMPLATE from 'raw-loader!./change-company-state.html';
export var ChangeCompanyStateComponent = {
    selector: 'changeCompanyState',
    component: {
        bindings: {
            companyInfo: '<',
            changeToState: '@',
            saveCallback: '&',
            cancelCallback: '&'
        },
        controller: ChangeCompanyStateController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/changeCompanyState/change-company-state.html'
    }
};
//# sourceMappingURL=change-company-state.component.js.map